import React from 'react'

export interface DatePickerContextValue {
  value: string | null
  onChange(date: string): unknown

  focus: string | null
  setFocus(date: string | null): void

  transitionState: 'none' | 'toNext' | 'toPrev' | 'init'

  goToNextMonth(): unknown
  goToPreviousMonth(): unknown

  shouldDisableDate(date: string): boolean
}

export const DatePickerContext = React.createContext<null | DatePickerContextValue>(null)

export interface DatePickerRootProps {
  children?: React.ReactNode
  value: DatePickerContextValue
}

export function DatePickerRoot({ children, value }: DatePickerRootProps) {
  return <DatePickerContext.Provider value={value}>{children}</DatePickerContext.Provider>
}
